import { render } from "./pendidikan-list-virtual-scroll.vue?vue&type=template&id=10ebeb50"
import script from "./pendidikan-list-virtual-scroll.vue?vue&type=script&lang=js"
export * from "./pendidikan-list-virtual-scroll.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__